import slugify from "slugify"
import { Paths } from "#/utils/Paths"
import type { HelpCenterArticle } from "./types"

export function helpCenterCategoryPath(categorySlug: string): string {
  return `${Paths.FAQS_CATEGORIES_BASE}/${categorySlug}`
}

export function helpCenterArticlePath(article: Pick<HelpCenterArticle, "id" | "title">): string {
  const vanity = slugify(article.title, { lower: true, strict: true })
  return vanity ? `${Paths.FAQS}/${vanity}-${article.id}` : `${Paths.FAQS}/${article.id}`
}

export function parseArticleIdFromPath(vanityAndId: string): string {
  const lastDash = vanityAndId.lastIndexOf("-")
  return lastDash < 0 ? vanityAndId : vanityAndId.slice(lastDash + 1)
}

export const helpCenterLinks = {
  providers: `${helpCenterCategoryPath("getting-care")}#providers`,
  bankAccountDetails: `${Paths.FAQS}/4T443JMZ9b8ebzLwrdrOcZ`
} as const
